import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as fromDisputeRequest from '../../create-dispute/create-dispute-request';
import { ServiceProviderService } from '../../../services/service-provider.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Subscription } from 'rxjs';
import { DisputeStorageService } from '../../../services/create-dispute-storage.service';

@Component({
  selector: 'app-create-dispute-summary',
  templateUrl: './create-dispute-summary.component.html',
  styleUrls: ['./create-dispute-summary.component.css'],
})

export class CreateDisputeSummaryComponent implements OnInit {

  @Output() selectSection = new EventEmitter<any>();

  showError: boolean = false;
  textMsg: any;
  disputeData: any;
  itemData: any;
  itemCADocumentNumber: any;
  isMasterSel: boolean;
  amount: any = 0.00;
  currency!: string;
  iId!: string;
  itemNumber: string = "0";
  disputeInvoiceLevel: boolean = true;
  bpNo: any;
  flag: boolean;
  dr: any;
  showLoader: boolean = false;
  submitted: boolean = false;
  message: any;
  formData: FormData = new FormData();
  fileName: String = "";
  disputeFormData: any = {};
  isInvoiceDispute: boolean = false;
  private subscription: Subscription = new Subscription();

  constructor(
    private modalService: NgbModal,
    private http: HttpClient,
    private spService: ServiceProviderService,
    private router: Router,
    private route: ActivatedRoute,
    private disputeStorageService: DisputeStorageService
  ) {
    this.flag = true;
    this.isMasterSel = false;
  }

  ngOnInit(): void {
    let disputeType = localStorage.getItem('dispute-type') || ''
    this.isInvoiceDispute = (disputeType == 'invoice-level-dispute') ? true : false;

    if (this.isInvoiceDispute) {
      this.disputeData = JSON.parse(localStorage.getItem('selected-invoice-to-dispute') || '') || history.state.invoice;
      let disputeType = localStorage.getItem('selected-type-to-dispute') || history.state.type;

      if (disputeType == 'invoice') {
        this.iId = this.disputeData.invoice_id;
        this.amount = parseFloat(this.disputeData.amount).toFixed(2);
        this.currency = this.disputeData.currency;
      } else if (disputeType == 'item') {
        this.itemData = JSON.parse(localStorage.getItem('selected-item-to-dispute') || '') || history.state.item;;
        this.itemNumber = this.itemData.itemNo
        this.iId = this.disputeData.invoice_id
        this.amount = parseFloat(this.itemData.itemCAAmountInTransactionCurrency).toFixed(2);
        this.currency = this.itemData.itemTransactionCurrency;
      }
    }
    else {
      this.disputeData = JSON.parse(localStorage.getItem('ban-data-to-dispute') || '') || history.state.banData;
      this.currency = this.disputeData.currency;
    }

    this.subscription.add(
      this.disputeStorageService.disputeFormState$.subscribe((storedValues) => {
        if (storedValues) {
          this.populateForm(storedValues);
        }
      })
    );
  }

  // Populate form with values from the store
  private populateForm(storedValues: any): void {
    if (Object.entries(storedValues).length != 0) {
      this.disputeFormData = storedValues;
      this.disputeStorageService.updateSummaryValue(80);
    }
    else {
      this.navigateToPreviousPage();
    }
  }

  // Unsubscribe to prevent memory leaks
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  prepareDisputeCreationData() {
    let inv = this.disputeData;
    this.dr = new fromDisputeRequest.DisputeRequest();
    this.dr.BusinessPartner = this.disputeData && this.disputeData.bpNo;
    this.dr.CADisputeExternalCallerCode = "EXT";
    this.dr.CADisputeType = this.disputeFormData.type;
    this.dr.CasePriority = this.disputeFormData.priority;
    this.dr.CaseReason = this.disputeFormData.reason;
    this.dr.ContractAccount = inv.caContract;
    this.dr.DisputeCaseCurrency = inv.currency;
    this.dr.InvoiceNumber = inv.invoice_id;
    this.dr.DisputedAmount = parseFloat(this.disputeFormData.amount);
    this.dr.CaseNoteText = this.disputeFormData.note;
    this.amount = this.dr.DisputedAmount;
    let drCaseObject = new fromDisputeRequest.DisputeCaseObject();
    drCaseObject.ObjectKey = this.itemCADocumentNumber;
    drCaseObject.ObjectType = "CA_DOC";
    this.dr._CACaseObject.push(drCaseObject);
    if (this.disputeFormData.fileName) {
      this.formData.append('file', this.disputeFormData.file, this.disputeFormData.fileName)
    }
  }

  createDispute(content: any) {
    this.prepareDisputeCreationData();
    this.disputeStorageService.updateSummaryValue(100);
    this.disputeStorageService.updateConfirmationValue(50);
    this.showLoader = true;
    this.message = "Creating Your Dispute"
    this.textMsg = "We are creating your dispute. Please wait for sometime.";
    this.modalService.open(content);
    this.spService.createDispute(this.dr).subscribe((res: any) => {
      this.showLoader = false;
      this.showError = false;
      let headers = new HttpHeaders()
      // .set('Content-Type', 'multipart/form-data')
      .set('Accept', 'application/json');
      let logTraceJSON: any = { 'eventSource': 'uploadDisputeAttachment', 'payload': this.formData, 'ban': this.disputeData && this.disputeData.bpNo, 'invoiceNumber': this.iId || '' };
      headers = headers.set('X-Log-Trace', JSON.stringify(logTraceJSON));
      let options = { headers: headers };
      if (this.disputeFormData.file) {
        this.http.post(environment.serverURL + environment.brimURI + 'dispute/attachment/' + res.caseUUID, this.formData, options)
          .subscribe(
            (res1: any) => {
              console.log(res1);
              this.message = "Dispute Successfully Created!";
              this.textMsg = "Dispute ID :" + res.caseUUID + " has been created successfully.";
              this.disputeStorageService.updateConfirmationValue(100);
            },
            (err: any) => {
              this.showError = true;
              this.message = "Error!";
              this.textMsg = "Something went wrong while uploading attachment, please try to upload it <a href='./view-my-dispute'>View My Dispute<a> screen.";
              console.log(err.message);
            }
          );
      } else {
        this.showLoader = false;
        this.showError = false;
        this.message = "Dispute Successfully Created!";
        this.textMsg = "Dispute ID :" + res.caseUUID + " has been created successfully.";
        this.disputeStorageService.updateConfirmationValue(100);
      }
    },
      (err: any) => {
        console.log("In error" + err);
        this.showError = true;
        this.message = "Network Error!";
        this.textMsg = "Something is temporarily wrong, please try again after sometime or contact to our support team.";
      }
    );
  }

  closeDisputePopup() {
    this.modalService.dismissAll();
    this.removeLocalStorageData();
    this.router.navigate(["view-my-dispute"], { relativeTo: this.route.parent });
  }

  removeLocalStorageData() {
    localStorage.removeItem('selected-invoice-to-dispute');
    localStorage.removeItem('selected-item-to-dispute');
    localStorage.removeItem('selected-type-to-dispute')
    localStorage.removeItem('ban-data-to-dispute');
    localStorage.removeItem('dispute-type');
    this.disputeStorageService.resetStore();
  }

  editdispute() {
    this.navigateToPreviousPage();
  }

  navigateToPreviousPage() {
    this.selectSection.emit('invoice-info')
  }
}